// src/api/recommendations.ts
import { api } from "./client";

export type RecItem = any;

function unwrap(res: any) {
  const body = res?.data ?? res;
  return body?.data?.items || body?.items || body?.data || body || [];
}

export async function probeRecommendations(limit = 20, filters: any = {}): Promise<RecItem[]> {
  try {
    // 🧠 Нормализуем фильтры в правильный формат, ожидаемый бэком
    const normalizedFilters = normalizeFilters(filters);

    const res = await api.get("/recommendations", {
      params: { limit },
    });

    const items = unwrap(res) as RecItem[];

    if (import.meta.env.VITE_PWA_DEV === "true"){
      console.info(
        "[recommendations] loaded:",
        items?.length || 0,
        "params:",
        { limit, ...normalizedFilters }
    );}
    return items;
  } catch (e: any) {
    console.error(
      "[recommendations] fail",
      e?.response?.status,
      e?.response?.data || e
    );
    return [];
  }
}

// 👉 действия
export async function rollback(profileId: string) {
  return api.post("/recommendations/rollback", { user_id: profileId });
}

export async function dislike(profileId: string) {
  return api.post("/recommendations/dislike", { user_id: profileId });
}

export async function like(profileId: string) {
  return api.post("/recommendations/like", { user_id: profileId, from_top: false });
}

export async function superlike(profileId: string) {
  return api.post("/recommendations/superlike", { user_id: profileId, from_top: false, comment: "" });
}

export async function activateSuperBoom() {
  try {
    const res = await api.post("/recommendations/superboom");
    const data = res?.data?.data || {};
    if (import.meta.env.VITE_PWA_DEV === "true") {console.log("✅ СуперБум активирован:", data);}
    return data;
  } catch (e: any) {
    console.error("❌ Ошибка при активации СуперБума:", e?.response?.data || e);
    throw e;
  }
}

/**
 * 🧩 Преобразует старый формат фильтров в формат, который принимает API
 */
function normalizeFilters(filters: any) {
  // show_me может быть массивом объектов [{key: "male"}] или строк ["male"]
  const show_me = Array.isArray(filters?.show_me)
    ? filters.show_me.map((item: any) =>
      typeof item === "string" ? item : item.key
    )
    : ["female"];

  // если есть min_age и max_age, объединяем в строку "min-max"
  const age_range =
    filters?.age_range ||
    (filters?.min_age && filters?.max_age
      ? `${filters.min_age}-${filters.max_age}`
      : "18-35");

  return {
    is_global_search: filters?.is_global_search ?? false,
    age_range,
    search_radius: filters?.search_radius ?? filters?.distance ?? 50,
    city: filters?.city ?? "",
    show_me,
  };
}

export async function getCompatibility(profileId: string) {
  return api.get("/recommendations/compatibility", {
    params: {
      partner_id: profileId,
    },
  });
}

export async function postCompatibility(profileId: string) {
  return api.post("/recommendations/compatibility", null, {
    params: {
      user_id: profileId,
    },
  });
}

export async function postBirthday(payload: {
  birth_date: string
  birth_time: string
}) {
  return api.post("/users/settings/birth", payload)
}

